import { useQuery } from "@tanstack/react-query";
import { getMessageTemplates } from "../api/indexedDB";
import { fetchMessageTemplates } from "../api/fetchMessageTemplates";
import { useAuth } from "../../../Context/AuthContext";
export const useGetMessageTemplates = () => {
  return useQuery({
    queryKey: ["messageTemplates"],
    queryFn: getMessageTemplates,
  });
};

export const useFetchMessageTemplates = () => {
  const auth = useAuth();
  const user = auth.getSessionData();

  return useQuery({
    queryKey: ["messageTemplatesForCampaigns"],
    queryFn: () => {
      return fetchMessageTemplates({
        token: user.token,
        uid_partner: user.uid_partner,
      });
    },
    refetchOnWindowFocus: false,
    initialData: [],
  });
};
